import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { hitsPerPage } = additionalData;

  return (
    <>
      {[...Array(hitsPerPage).keys()].map((i) => (
        <div className="col-12 col-sm-6 col-xl-4 d-flex" key={i}>
          <div className="card-product">
            <div className="card-product-img" />
            <div className="card-product-body">
              <h3 className="placeholder-glow">
                <span className="placeholder col-12" />
              </h3>
              <p className="placeholder-glow">
                <span className="placeholder col-12" />
              </p>
            </div>
            <div className="card-product-foot">
              <p className="placeholder-glow">
                <span className="placeholder col-12" />
              </p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
